import { useEffect, useState } from 'react';

/**
 * Publikus (bejelentkezés nélküli) oldalak saját téma-kapcsolója.
 * Független az app témájától: a választás a publicTheme kulcs alatt marad meg,
 * alapértelmezés a rendszer beállítása. A <html> 'dark' osztályát az oldal
 * élettartamára átveszi, majd visszaállítja.
 */
export function usePublicTheme() {
  const [theme, setTheme] = useState<'light' | 'dark'>(() => {
    try {
      const saved = localStorage.getItem('publicTheme');
      if (saved === 'light' || saved === 'dark') return saved;
    } catch { /* privát mód */ }
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    const hadDark = root.classList.contains('dark');
    if (theme === 'dark') root.classList.add('dark'); else root.classList.remove('dark');
    root.style.colorScheme = theme;
    try { localStorage.setItem('publicTheme', theme); } catch { /* ignore */ }
    return () => {
      if (hadDark) root.classList.add('dark'); else root.classList.remove('dark');
      root.style.colorScheme = '';
    };
  }, [theme]);

  return { theme, toggle: () => setTheme(t => (t === 'dark' ? 'light' : 'dark')) };
}
